/** 每题限时 (秒) */
export const TIME_PER_QUESTION = 20;
/** 每局题目数 */
export const QUESTIONS_PER_GAME = 10;
/** 每局难度分布: [简单数, 中等数, 困难数] */
export const DIFFICULTY_DISTRIBUTION = {
    1: 3,
    2: 4,
    3: 3,
};
/** 基础分 */
export const BASE_SCORES = {
    1: 10,
    2: 20,
    3: 30,
};
/** 时间奖励系数 (分/秒) */
export const TIME_BONUS_COEFF = {
    1: 0.5,
    2: 1,
    3: 1.5,
};
/** 服务端分数校验容差 */
export const SCORE_VALIDATION_TOLERANCE = 5;
/**
 * 计算单题得分
 * 公式: 基础分 + floor(剩余时间) × 时间奖励系数
 */
export function calculateQuestionScore(difficulty, timeLeftSeconds) {
    const base = BASE_SCORES[difficulty];
    const coeff = TIME_BONUS_COEFF[difficulty];
    const bonus = Math.floor(timeLeftSeconds) * coeff;
    return Math.round(base + bonus);
}
/**
 * 计算整局总分
 */
export function calculateTotalScore(difficulties, timeTakenMs, answeredCorrectly) {
    return difficulties.reduce((total, diff, i) => {
        if (!answeredCorrectly[i])
            return total;
        const timeLeft = TIME_PER_QUESTION - timeTakenMs[i] / 1000;
        return total + calculateQuestionScore(diff, Math.max(0, timeLeft));
    }, 0);
}
//# sourceMappingURL=scoring.js.map